import React from 'react';
import * as s from './styled-modal-shell';

const ModalShell = ({
  id = 'modal',
  title,
  subtitle,
  requiredHint,
  unfilled,
  width,
  height,
  onRequestClose,
  children,
}) => {
  const handleOutsideClick = (e) => {
    if (e.target.id === id && onRequestClose) {
      e.preventDefault();
      onRequestClose();
    }
  };

  return (
    <s.Overlay
      id={id}
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={handleOutsideClick}
    >
      <s.Container width={width} height={height}>
        <s.CloseButton
          type="button"
          aria-label="Fechar"
          onClick={(e) => {
            e.stopPropagation();
            if (onRequestClose) onRequestClose();
          }}
        >
          X
        </s.CloseButton>
        <s.Header>
          {title && <s.Title>{title}</s.Title>}
          {subtitle && <s.Subtitle>{subtitle}</s.Subtitle>}
          {requiredHint && (
            <s.RequiredHint unfilled={unfilled}>{requiredHint}</s.RequiredHint>
          )}
        </s.Header>
        {children}
      </s.Container>
    </s.Overlay>
  );
};

export default ModalShell;
